import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  FETCH_IMAGE_BY_UUID({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.image.getByUUID(
        uuid,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/images.js